import { useCallback } from 'react';
import { mutate } from 'swr';

import { VISIT_AUTO_CANCEL_INFO_QUERY } from 'src/components/pages/pageElements/videoConference/useSWRVisitAutoCancelInfo.gql';
import { SET_SESSION_OVERLAPPED_AT_MUTATION } from 'src/components/pages/pageElements/videoConference/useSetSessionOverlappedAt.gql';
import useApolloClient from 'src/shared/client/useApolloClient';

export const useSetSessionOverlappedAt = () => {
  const apolloClient = useApolloClient();

  const setSessionOverlappedAt = useCallback(
    async (eventId: string) => {
      try {
        await apolloClient.mutate({
          mutation: SET_SESSION_OVERLAPPED_AT_MUTATION,
          variables: { eventId },
        });

        // Invalidate the SWR cache for this specific event's auto-cancel info
        // This will cause the query to re-fetch and show the updated state
        await mutate([VISIT_AUTO_CANCEL_INFO_QUERY, { eventId }]);

        return { success: true };
      } catch (error) {
        console.error('Error setting session overlapped at:', error);
        return { success: false, error };
      }
    },
    [apolloClient],
  );

  return {
    setSessionOverlappedAt,
  };
};
